import { Card, Skeleton, Row, Col, Typography, Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox, faTruck, faBoxesStacked, faTriangleExclamation, faUsers, faMap, faMapLocationDot, faCubes } from "@fortawesome/free-solid-svg-icons";
const { Text, Title } = Typography;

const formatNumber = (num) =>
  new Intl.NumberFormat("es-CO").format(num);

export default function DashboardCards({ stock, alertas, movimientos, loading }) {
  if (loading) {
    return (
      <Row gutter={[16, 16]}>
        {Array.from({ length: 8 }).map((_, i) => (
          <Col xs={24} sm={12} lg={6} key={i}>
            <Card>
              <Skeleton active paragraph={{ rows: 1 }} />
            </Card>
          </Col>
        ))}
      </Row>
    );
  }

  const totalProductos =
    stock?.filter(s => Number(s.stock_disponible) > 0).length ?? 0;

  const totalEntregas =
    movimientos?.reduce(
      (sum, m) => sum + Number(m.cantidad || 0),
      0
    ) ?? 0;

  const totalMovimientos = movimientos?.length ?? 0;

  const totalAlertas =
    alertas?.filter(a => Number(a.stock_disponible) < 0).length ?? 0;

  const entidadesUnicas =
    new Set((movimientos || []).map(m => m.identificacion)).size;

  const productosUnicos =
    new Set(movimientos.map(m => m.oid_producto)).size;

  const departamentosUnicos =
    new Set(movimientos.map(m => m.departamento)).size;

  const municipiosUnicos =
    new Set(movimientos.map(m => m.municipio)).size;

  const cards = [
    {
      title: "Productos en stock",
      value: totalProductos,
      icon: faBox,
      color: "#1677ff",
      bg: "#e6f4ff",
      tooltip: "Cantidad de productos registrados en inventario"
    },
    {
      title: "Unidades entregadas",
      value: totalEntregas,
      icon: faTruck,
      color: "#52c41a",
      bg: "#f6ffed",
      tooltip: "Total de unidades entregadas a participantes"
    },
    {
      title: "Registros",
      value: totalMovimientos,
      icon: faBoxesStacked,
      color: "#722ed1",
      bg: "#f9f0ff",
      tooltip: "Cantidad de registros de movimientos"
    },
    {
      title: "Alertas stock",
      value: totalAlertas,
      icon: faTriangleExclamation,
      color: "#fa8c16",
      bg: "#fff7e6",
      tooltip: "Productos con bajo stock o inconsistencias"
    },
    {
      title: "Beneficiarios",
      value: entidadesUnicas,
      icon: faUsers,
      color: "#13c2c2",
      bg: "#e6fffb",
      tooltip: "Cantidad de participantes u organizaciones que recibieron entregas"
    },
    {
      title: "Productos entregados",
      value: productosUnicos,
      icon: faCubes,
      color: "#2f54eb",
      bg: "#f0f5ff",
      tooltip: "Cantidad de productos distintos entregados"
    },
    {
      title: "Departamentos",
      value: departamentosUnicos,
      icon: faMap,
      color: "#fa541c",
      bg: "#fff2e8",
      tooltip: "Departamentos donde se realizaron entregas"
    },
    {
      title: "Municipios",
      value: municipiosUnicos,
      icon: faMapLocationDot,
      color: "#eb2f96",
      bg: "#fff0f6",
      tooltip: "Municipios con entregas registradas"
    }
  ];

  return (
    <Row gutter={[24, 24]}>
      {cards.map((card, index) => ( 
        <Col xs={24} sm={24} lg={6} key={index}>
          <Tooltip title={card.tooltip}>
            <Card
              hoverable
              style={{
                borderRadius: 12
              }}
              styles={{
                body: {

                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between"
                }
              }}
            >
              <div style={{ padding: 12 }}>
                <Text type="secondary" >{card.title}</Text>
                <Title
                  level={3}
                  style={{ margin: 0, fontWeight: 600 }}
                >
                  {formatNumber(card.value)}
                </Title>
              </div>

              <div
                style={{
                  background: card.bg,
                  color: card.color,
                  padding: "12px",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <FontAwesomeIcon icon={card.icon} size="lg" />
              </div>
            </Card>
          </Tooltip>
        </Col>
      ))}
    </Row>
  );
}